import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Button, { ButtonVariant } from 'components/base/Button';

interface BotaoCriarNFeProps {
  size?: 'sm' | 'lg';
  variant?: ButtonVariant;
  className?: string;
  children?: React.ReactNode;
}

const BotaoCriarNFe: React.FC<BotaoCriarNFeProps> = ({
  size,
  variant = 'primary',
  className = '',
  children,
}) => {
  const navigate = useNavigate();

  return (
    <Button
      variant={variant}
      size={size}
      onClick={() => navigate('/operacional/nfe/novo')}
      className={`d-flex align-items-center ${className}`}
    >
      <FontAwesomeIcon icon={faPlus} className="me-2" />
      {children || 'Nova NFe'}
    </Button>
  );
};

export default BotaoCriarNFe;
